import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import HoursGrid from "../HoursGrid";
import { MonthPicker } from "./MonthPicker";

export function HoursGridWrapper() {
  const today = new Date();
  const [month, setMonth] = useState(`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`);
  const [holidaysByDate, setHolidaysByDate] = useState({});
  const [projects, setProjects] = useState([]);
  const [regii, setRegii] = useState([]);
  const [y] = month.split("-").map(Number);

  useEffect(() => {
    api.get(`/holidays?year=${y}`).then((r) => {
      const map = {};
      for (const h of (r.data || [])) map[h.date] = h;
      setHolidaysByDate(map);
    }).catch(() => setHolidaysByDate({}));
    api.get("/projects").then((r) => setProjects(r.data || [])).catch(() => setProjects([]));
    api.get("/regii").then((r) => setRegii(r.data || [])).catch(() => setRegii([]));
  }, [y]);

  return (
    <div className="space-y-3">
      <div className="card-flat p-3">
        <MonthPicker value={month} onChange={setMonth}/>
        <p className="text-[11px] text-zinc-500 mt-2">
          📊 Click pe orice celulă pentru a edita orele lucrate (sus, albastru) și conduse (jos, portocaliu).
          Fundalul colorat al celulei = culoarea proiectului. Sâmbăta lucrătoare, duminica și sărbătorile naționale negre.
        </p>
      </div>
      <HoursGrid month={month} holidaysByDate={holidaysByDate} projects={projects} regii={regii}/>
    </div>
  );
}
